import Header from "../Component/Header";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import { useState } from "react";

const YEAR_PDF_URLS = {
    "2026-27": "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/pdf/year_planner_2026_27.pdf",
    "2025-26": "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/pdf/Year-Planner.pdf",
};

const YearPlanner = () => {
    const [selectedYear, setSelectedYear] = useState("2026-27");
    const iframeSrc = YEAR_PDF_URLS[selectedYear];
    // Add #toolbar=0 to hide the PDF toolbar
    const iframeSrcWithoutToolbar = iframeSrc ? `${iframeSrc}#toolbar=0` : null;

    return (
        <>
            <Header />
            <Breadcrumb title="Year Planner" mid="About Us &nbsp; &nbsp;|" tabName="Year Planner" />
            <div className="innerPage year_planner">
                <div className="container">
                    <div className="year-planner-wrap">
                        {iframeSrcWithoutToolbar ? (
                            <iframe
                                src={iframeSrcWithoutToolbar}
                                width="100%"
                                height="800"
                                title={`Year Planner ${selectedYear}`}
                                style={{ border: 'none' }}
                            />
                        ) : (
                            <div className="year-planner-placeholder">
                                <p>
                                    The iframe link for <strong>{selectedYear}</strong> is pending.
                                </p>
                            </div>
                        )}
                        <ul className="year-planner-years">
                            {Object.keys(YEAR_PDF_URLS).map((year) => (
                                <li
                                    key={year}
                                    className={selectedYear === year ? "active" : ""}
                                    onClick={() => setSelectedYear(year)}
                                    role="button"
                                    tabIndex={0}
                                >
                                    {year}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default YearPlanner;